// src/config.js

// Normalize a raw base URL value (from env or secret):
// - Trim whitespace (guards against trailing newlines from `echo | gh secret set`)
// - Prepend https:// if the scheme is missing (guards against secrets set as
//   bare hostnames like "api.graspd.ai")
// - Strip trailing slashes
// Returns '' for empty/whitespace input so the caller's fallback can apply.
function normalizeBase(url) {
  const u = String(url ?? '').trim();
  if (!u) return '';
  const withScheme = /^https?:\/\//i.test(u) ? u : `https://${u}`;
  return withScheme.replace(/\/+$/, '');
}

// API base URL is not a secret — hardcode the prod default so deploys work
// even if REACT_APP_API_BASE_URL isn't injected at build time. Env var still
// wins when set (useful for staging / local dev pointing elsewhere).
export const CONFIG = {
  API_BASE_URL: normalizeBase(process.env.REACT_APP_API_BASE_URL) || 'https://api.graspd.ai',
  USER_ID: process.env.REACT_APP_USER_ID || '111',   // TODO: replace with Firebase auth UID
  // Stripe publishable key (pk_...) — safe to expose in the client bundle, so
  // it's configured like other public config rather than a build secret. Must
  // be set per environment (test key for staging/dev, live key for prod);
  // there is no sensible hardcoded default.
  STRIPE_PUBLISHABLE_KEY: (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '').trim(),
};